<template>
  <div class="location">
    <div class="table-places-container">
      <TablePLaces :place-list="getLocationPlaces" @select-table="onSelectNewPlace"
        @show-mobile-calendar="showMobileCalendar" v-if="getLocationPlaces && getSelectedLocation"
        :location="getSelectedLocation" />

      <info-label class="animate__animated animate__fadeInLeft" label1="Доступно" label2="Занято" label3="Свободно" />
    </div>
    <div class="booking-total">
      <p v-if="getOrderPrice" class="booking-price">{{ getOrderPrice }}</p>
      <ButtonWithIcon class="booking-button" button-text="Забронировать" @clicked="openForm" buttonType="apply"
                      :isBlocked="!isPlaceSelected">
        <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4.16602 9.99996H15.8327M15.8327 9.99996L9.99935 4.16663M15.8327 9.99996L9.99935 15.8333"
                stroke="white" stroke-width="1.67" stroke-linecap="round" stroke-linejoin="round" />
        </svg>
      </ButtonWithIcon>


    </div>
  </div>
</template>

<script>
  import Place from './Place.vue'
  import { EventBus } from '@/eventBus'
  import InfoLabel from './InfoLabel.vue'
  import TablePLaces from "./Places/TablePlaces.vue";
  import CustomButton from './Inputs/CustomButton.vue';
  import ButtonWithIcon from "./Inputs/ButtonWithIcon.vue";

  export default {
    components: {ButtonWithIcon, TablePLaces, InfoLabel, Place, CustomButton },
    name: 'Location',
    computed: {
      isPlaceSelected() {
        return this.$store.getters.isSelectedPlace
      },
      getOrderPrice() {
        return this.$store.getters.orderPrice
      },
      getLocationPlaces() {
        return this.$store.state.locationPlaces
      },
      getSelectedLocation() {
        return this.$store.state.selectedLocation
      }
    },
    created: function () {
      EventBus.$on('changeLocation', this.onChangeLocation)
    },
    beforeDestroy: function () {
      EventBus.$off('changeLocation', this.onChangeLocation)
    },
    methods: {
      openForm() {
        let data = {
          bookingType: 'BOOKING',
          bookingData: null
        }
        EventBus.$emit('openForm', data)
      },
      onChangeLocation(newLocation) {
        this.$store.dispatch('selectLocation', newLocation)
        this.$store.dispatch('fetchPlaces')
        this.$store.dispatch('fetchAvailablePlaces')
      },
      onSelectNewPlace(place) {
        this.$store.dispatch('selectPlace', place)
      },
      showMobileCalendar() {
        this.$emit('show-mobile-calendar')
      }
    }
  }
</script>

<style scoped>
.animate__fadeInLeft {
  display: none;
}

.location {
  width: 100%;

  display: flex;
  flex-direction: column;
  position: relative;
  justify-content: space-between;

  /* Add space for the booking-total */
}

.table-places-container {
  flex: 1;
  width: 100%;
  overflow-y: auto;
}
.booking-total {
  display: none;
  margin: 10px auto;
  z-index: 10;
  width: 95%;

}

.booking-price {
  color: rgba(52, 64, 84, 1);
  font-weight: 700;
  border-bottom: 1px solid rgba(234, 236, 240, 1);
  padding-bottom: 5px;
}

.booking-button {
  background-color: var(--beel-primary);
  color: white;
}
/* For larger screens, we can add some max-width constraints if needed */
@media (min-width: 1400px) {
  .table-places-container {
    max-width: 1400px;
    margin: 0 auto;
  }
}

/* For mobile screens, ensure everything fits properly */
@media (max-width: 768px) {
  .booking-total {
    display: block;
  }


  .booking-button {
    margin-top: 12px;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/client/Location.vue